<template>
  <v-row dense class="file-edit-content">
    <v-col xs="12" sm="12" md="12">
      <file-comment-dialog
        :rowStatuses="rowStatuses"
        @refresh="getRows"
        ref="commentDialog"
      />
      <GeneratedLinkDialog ref="generatedLinkDialog" />

      <v-row dense>
        <v-col cols="12">
          <FileHeader
            ref="fileHeader"
            :result="result"
            :versions="versions"
            :latestVersion="versions[0] || {}"
            :statistics="result.statistics"
            :errors="result.errors"
            :bulkNumberOfRows="bulkNumberOfRows"
            :task="result.task"
            :rowStatuses="rowStatuses"
            :sessionStatus="sessionStatus"
            :analyseLoading="analyseLoading"
            :importLoading="importLoading"
            :reMatchLoading="reMatchLoading"
            @onFiltersChanged="onFiltersChanged"
            @onGenerateLink="handleGenerateLink"
            @onBulkImport="bulkImport"
            @onBulkAnalyze="bulkAnalyse"
            @onBulkSetStatus="bulkSetStatus"
            @onReMatch="reMatch"
            @onEnvChanged="onEnvChanged"
            @onSmartStatusApply="handleSmartStatusApply"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col xs="12" sm="12" md="12">
          <v-tabs v-model="tab" color="primary" background-color="transparent">
            <v-tab v-for="tab in tabsItems" :key="tab.id">
              {{ tab.title }}
            </v-tab>
          </v-tabs>
          <v-divider class="pt-5" horizontal />
          <v-card flat>
            <file-table
              ref="fileTable"
              @showStatusChangeMenu="showStatusChangeMenu"
              @showComments="showComments"
              @setStatus="setStatus"
              @onPaginationChange="getRows"
              @onUpdateRow="updateRow"
              @onRowsSelected="getBulkNumberOfRows()"
              @onCompoundedChanged="updatePropsStructure"
              :headerName="selectedTab.title"
              :rows="rows"
              :headers="[...CommonHeaders, ...selectedTab.headers]"
              :params="selectedTab.params"
              :filters="filters"
              :loading="loading"
              :totalItems="totalItems"
              :analysingRows="sessionStatus.analyze_rows_ids"
              :importingRows="sessionStatus.import_rows_ids"
            />
          </v-card>

          <StatusChangeMenuVue
            @setStatus="setStatus"
            :rowStatuses="rowStatuses"
            :sessionStatus="sessionStatus"
            :analyseLoading="analyseLoading"
            :importLoading="importLoading"
            ref="statusChangeMenuVue"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import _ from 'lodash';
import FileTable from '../../components/files/FileTable';
import FileCommentDialog from '../../components/files/FileCommentDialog';
import FileHeader from '../../components/files/FileHeader';
import GeneratedLinkDialog from '../../components/tasks/GeneratedLinkDialog';
import StatusChangeMenuVue from '../../components/files/StatusChangeMenu.vue';

import { GlobalConfig } from '@/shared/GlobalAppconfig.class';
import { TABS, DEFAULTS, CommonHeaders } from '@/constants';
import {
  processingResultsApiV1,
  tasksApiV1,
  breedsApiV1,
  rowStatusesV1
} from '@/api/v1';
import {
  breedsApiV2,
  processingResultsApiV2,
  rowStatusesV2,
  tasksApiV2
} from '@/api/v2';
import { generateCustomerLink } from '@/utils/generateCustomerLink';
import { MatcherTaskVersion } from '@/constants/task';

export default {
  computed: {},
  data: () => ({
    CommonHeaders,
    environment: undefined,
    tabsItems: TABS,
    tab: 0,
    loading: false,
    filters: {},
    rowStatuses: [],
    rows: [],
    versions: [],
    task_id: undefined,
    totalItems: 0,
    result: {
      errors: [],
      task: {
        upload: {
          file: {}
        },
        business: {}
      }
    },
    analyseLoading: false,
    importLoading: false,
    reMatchLoading: false,
    sessionStatus: {
      re_match_status: 'IN_PROGRESS',
      analyze_status: 'IN_PROGRESS',
      import_status: 'IN_PROGRESS',
      analyze_rows_ids: [],
      import_rows_ids: [],
      task: {}
    },
    importStatusesInterval: undefined,
    selectedTab: TABS[0],
    bulkNumberOfRows: {
      status: 0,
      analyse: 0,
      import: 0
    },
    isRowsFetching: false
  }),

  mounted() {
    if (!this.$route.params.result_id) this.$router.go(-1);
    this.init();
  },
  watch: {
    tab(newVal) {
      this.selectedTab = this.tabsItems[newVal];
      this.$refs.fileTable.resetPagination();
      this.onFiltersChanged();
    },
    $route() {
      clearInterval(this.importStatusesInterval);
      this.init();
    }
  },
  beforeDestroy() {
    clearInterval(this.importStatusesInterval);
    GlobalConfig.config.navigation.mini = true;
  },
  components: {
    FileHeader,
    FileTable,
    FileCommentDialog,
    StatusChangeMenuVue,
    GeneratedLinkDialog
  },
  methods: {
    init() {
      GlobalConfig.config.navigation.mini = true;

      return Promise.all([
        this.getAnalyzeAndImportStatuses().then(
          (res) => (this.sessionStatus = res)
        ),
        this.refresh({ withResult: true, withRowStatuses: true })
      ])
        .then(() => {
          this.importStatusesInterval = setInterval(() => {
            this.getAnalyzeAndImportStatuses().then(
              this.verifyAnalyseAndImportStatus.bind(this)
            );
          }, 2000);
        })
        .catch((err) => console.log(err));
    },
    onFiltersChanged(filters = {}) {
      if (filters) this.filters = filters;

      if (filters.showPrice !== this.filters.showPrice) {
        return;
      }

      this.$refs.fileTable.resetPagination();
      this.refresh();
    },
    openFile(file) {
      window.open(file.location, '_blank');
    },
    getBulkNumberOfRows() {
      return Promise.all([
        this.getNumberOfRows('status'),
        this.getNumberOfRows('analyse'),
        this.getNumberOfRows('import')
      ]).then(([statusCount, analyseCount, importCount]) => {
        this.bulkNumberOfRows = {
          status: statusCount,
          analyse: analyseCount,
          import: importCount
        };
      });
    },
    refresh(
      opt = {
        withResult: false,
        withAnalyseAndImportStatus: false,
        withRowStatuses: false
      }
    ) {
      return Promise.all([
        this.getRows(false),
        opt.withResult ? this.getResult() : Promise.resolve(),
        opt.withAnalyseAndImportStatus
          ? this.getAnalyzeAndImportStatuses().then(
              this.verifyAnalyseAndImportStatus.bind(this)
            )
          : Promise.resolve(),
        opt.withRowStatuses ? this.getRowStatuses() : Promise.resolve()
      ])
        .then(() => this.$refs.fileTable.resetSelection())
        .then(() => this.getBulkNumberOfRows())
        .catch((err) => {
          console.log('Refresh Error: ', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVersions() {
      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .fetchProcessingResultsForTask(this.task_id)
        .then((response) => {
          this.versions = response;
        });
    },
    async getRowStatuses() {
      const { items } = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? rowStatusesV2
          : rowStatusesV1
      ).fetchRowStatuses();

      this.rowStatuses = items;
    },
    getResult() {
      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .fetchResult(this.$route.params.result_id)
        .then((response) => {
          this.result = response;
          this.task_id = this.result.task.id;
          this.getVersions();
          GlobalConfig.config.businessName = this.result.task.business.name;
          GlobalConfig.config.taskName = this.result.task.name;
        });
    },
    async getRows(stopLoadingOnCall = true) {
      if (this.isRowsFetching) return;

      this.loading = true;
      this.isRowsFetching = true;
      this.rows = [];
      const pagination = this.$refs.fileTable.getPagination();
      const rowsResults = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).fetchRows(this.$route.params.result_id, {
        ...this.getListQueryParameters(),
        page: pagination.page || 1,
        rowsPerPage: pagination.itemsPerPage,
        sortBy: pagination.sortBy,
        descending:
          pagination.sortDesc &&
          pagination.sortDesc.length &&
          pagination.sortDesc[0]
            ? true
            : undefined
      });
      this.rows = rowsResults.items;
      this.isRowsFetching = false;

      if (rowsResults.pagination) {
        this.totalItems = rowsResults.pagination.rowCount;
      }

      if (stopLoadingOnCall) {
        this.loading = false;
      }
    },
    async updateRow(row_id, updated) {
      try {
        const isCodeChanged =
          _.has(updated, 'rhapsody_code_override') ||
          _.has(updated, 'variation');
        const statusName = isCodeChanged ? 'needs_code_change' : 'needs_change';
        const status = this.rowStatuses.find(({ name }) => name === statusName);
        const shouldUpdateStatus = !_.has(updated, 'reviewed');

        this.loading = true;

        const updatedRow = await (
          this.$store.getters.isMatcherApiV2Enabled
            ? processingResultsApiV2
            : processingResultsApiV1
        ).updateRow(this.$route.params.result_id, row_id, {
          ...(shouldUpdateStatus ? { status } : {}),
          ...updated
        });

        _.merge(_.find(this.rows, { id: row_id }), updatedRow);

        if (shouldUpdateStatus) {
          this.getStatistics();
        }

        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    updatePropsStructure(rowId, propsId, updatedProps) {
      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .updateResultRowPropsStucture({
          resultId: this.$route.params.result_id,
          rowId,
          propsId,
          updatedProps
        })
        .then(() => this.refresh())
        .catch((err) => console.log(err));
    },
    getAnalyzeAndImportStatuses() {
      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).fetchAnalyzeAndImportStatuses(
        this.$route.params.result_id,
        this.environment
      );
    },
    verifyAnalyseAndImportStatus(res) {
      if (
        res.analyze_status !== this.sessionStatus.analyze_status ||
        res.import_status !== this.sessionStatus.import_status ||
        res.re_match_status !== this.sessionStatus.re_match_status
      )
        this.refresh({ withResult: true });

      this.sessionStatus = res;
    },
    showStatusChangeMenu(...params) {
      this.$refs.statusChangeMenuVue.showContextMenu(...params);
    },
    showComments() {
      const selected = this.$refs.fileTable.getSelectedRow();
      this.$refs.commentDialog.open(selected);
    },
    getListQueryParameters() {
      return {
        multimatch: this.filters.multimatch
          ? DEFAULTS.MULTIMATCH_FIELDS
          : undefined,
        exclude: {
          ...(this.selectedTab.params && this.selectedTab.params.exclude
            ? this.selectedTab.params.exclude
            : {}),
          statusesNames: this.filters.excludeIgnore ? ['ignore'] : undefined
        },
        ...this.selectedTab.params,
        search: this.filters.search || undefined,
        searchContext: this.filters.searchContext || undefined,
        statuses:
          this.filters.statuses && this.filters.statuses.length
            ? this.filters.statuses
            : undefined,
        reviewed: this.filters.reviewed || undefined,
        customerVerified: this.filters.customerVerified || undefined
      };
    },
    reMatch(context, isAdvanced) {
      this.reMatchLoading = true;
      return (
        this.$store.getters.getFeatureToggleByNameEnabled('matcher_api_v2')
          ? tasksApiV2
          : tasksApiV1
      )
        .reRunTask({
          taskId: this.task_id,
          action: 're-match',
          result_id: this.$route.params.result_id,
          context,
          isAdvanced
        })
        .then(() => {
          this.sessionStatus = {
            re_match_status: 'IN_PROGRESS',
            ...this.sessionStatus
          };
          this.reMatchLoading = false;
          return this.refresh({
            withAnalyseAndImportStatus: true,
            withResult: true
          });
        })
        .catch((err) => {
          console.log('ERR: ', err);
          this.reMatchLoading = false;
        });
    },
    onEnvChanged(env) {
      console.log('selectedEnv2: ', env);
      this.environment = env;
      this.getBulkNumberOfRows();
    },
    bulkAnalyse() {
      this.analyseLoading = true;
      const selected = this.$refs.fileTable.getSelectedRows();

      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .startAnalyzeRows({
          resultId: this.$route.params.result_id,
          environment: this.environment,
          resultContextParams:
            selected && selected.length
              ? { rows_ids: selected.map((s) => s.id) }
              : this.getListQueryParameters()
        })
        .then(() => {
          this.sessionStatus = {
            ...this.sessionStatus,
            analyze_status: 'IN_PROGRESS'
          };
          console.log('STARTED: ', this.sessionStatus);
          this.analyseLoading = false;
          return this.refresh({
            withAnalyseAndImportStatus: true,
            withResult: true
          });
        })
        .catch((err) => {
          console.log('ERR: ', err);
          this.analyseLoading = false;
        });
    },
    bulkImport() {
      this.importLoading = true;
      const selected = this.$refs.fileTable.getSelectedRows();

      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .startImportRows({
          resultId: this.$route.params.result_id,
          environment: this.environment,
          resultContextParams:
            selected && selected.length
              ? { rows_ids: selected.map((s) => s.id) }
              : this.getListQueryParameters()
        })
        .then(() => {
          this.sessionStatus = {
            import_status: 'IN_PROGRESS',
            ...this.sessionStatus
          };
          this.importLoading = false;
          return this.refresh({
            withAnalyseAndImportStatus: true,
            withResult: true
          });
        })
        .catch((err) => {
          console.log('ERR: ', err);
          this.importLoading = false;
        });
    },
    bulkSetStatus(status) {
      this.loading = true;
      const selected = this.$refs.fileTable.getSelectedRows();

      console.log('bulkSetStatus: ', selected);

      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .bulkUpdateResultRowStatus({
          resultId: this.$route.params.result_id,
          status,
          resultContextParams:
            selected && selected.length
              ? { rows_ids: selected.map((s) => s.id) }
              : this.getListQueryParameters()
        })
        .then(() => this.refresh({ withResult: true }));
    },
    setStatus({ status, multimatch, correct_rows_ids }) {
      this.loading = true;
      const selectedRow = multimatch
        ? undefined
        : this.$refs.fileTable.getSelectedRow();

      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .updateResultRowStatus({
          resultId: this.$route.params.result_id,
          rowIds: selectedRow ? [selectedRow.id] : undefined,
          status,
          filters: {
            multimatch: multimatch ? DEFAULTS.MULTIMATCH_FIELDS : undefined,
            multimatch_value: multimatch ? multimatch : undefined,
            correct_rows_ids
          }
        })
        .then((newStatus) => {
          if (selectedRow) {
            const row = _.find(this.rows, { id: selectedRow.id });

            row.status = newStatus;
            row.status_id = newStatus.id;

            this.getStatistics();

            this.loading = false;
          } else {
            this.refresh();
          }
        });
    },
    addComment() {
      const selected = this.$refs.fileTable.getSelectedRow();
      this.$refs.commentDialog.open(selected);
    },
    async handleGenerateLink(linkType) {
      const resultId = this.$route.params.result_id;
      this.loading = true;
      const task = this.result.task;
      const isUnresolvedBreedsAvailable = Boolean(
        linkType === DEFAULTS.LINKS_TYPES_MAP.MIG_PAL_LINK &&
          !task.breedState?.id &&
          this.$store.getters.isMatcherApiV2Enabled
          ? task.rhapsody_completed_import_request_id
          : task.rhapsody_enterprise_session_id
      );

      if (isUnresolvedBreedsAvailable) {
        this.result.task.breedState = await (
          this.$store.getters.isMatcherApiV2Enabled ? breedsApiV2 : breedsApiV1
        ).startUnresolvedBreedsProcessing(this.task_id);
      }

      const accessToken = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).fetchCustomerLinkAccessToken(resultId, linkType);

      const link = generateCustomerLink(
        resultId,
        linkType,
        accessToken,
        this.$store.getters.isMatcherApiV2Enabled
          ? MatcherTaskVersion.V2
          : MatcherTaskVersion.V1
      );
      this.$refs.generatedLinkDialog.open(link);
      this.loading = false;
    },
    getNumberOfRows(operation) {
      const selected = this.$refs.fileTable.getSelectedRows();

      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).fetchResultRowCount({
        resultId: this.$route.params.result_id,
        operation,
        environment: this.environment,
        resultContextParams:
          selected && selected.length
            ? { rows_ids: selected.map((s) => s.id) }
            : this.getListQueryParameters()
      });
    },
    getStatistics() {
      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .fetchResultStatistics(this.$route.params.result_id)
        .then((statistics) => {
          this.result.statistics = statistics;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async handleSmartStatusApply() {
      const resultId = this.$route.params.result_id;

      this.loading = true;

      await (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).applySmartStatus(resultId);

      this.refresh({ withResult: true });
    }
  }
};
</script>
